document.addEventListener('DOMContentLoaded', function() {
    const navigationItems = document.querySelectorAll(
        '.navigation .menu-item-has-children');
    const content = document.querySelector('.content');
    const siteFooter = document.querySelector('#site-footer');
    const search = document.querySelector('.search-toggle');
    const book = document.querySelector('#flyout-book');
    const logo = document.querySelector('.logo');

    let currentActiveItem = null;

    navigationItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
            if (currentActiveItem) {
                currentActiveItem.classList.remove('active');
            }

            item.classList.add('active');
            currentActiveItem = item;
        });
    });

    const removeActiveClass = function() {
        if (currentActiveItem) {
            currentActiveItem.classList.remove('active');
            currentActiveItem = null;
        }
    };

    content.addEventListener('mouseenter', removeActiveClass);
    siteFooter.addEventListener('mouseenter', removeActiveClass);
    search.addEventListener('mouseenter', removeActiveClass);
    book.addEventListener('mouseenter', removeActiveClass);
    logo.addEventListener('mouseenter', removeActiveClass);
});

// Get all the links in the submenu
const links = document.querySelectorAll('#subnav a');

// Get the container holding the links
const subnavContainer = document.querySelector('#subnav');

// Variable to store the debounce timeout
let scrollTimeout;

// Function to check which section is in view
function updateActiveLink() {
    // Get the current scroll position
    let currentScroll = window.scrollY;

    links.forEach(link => {
        // Get the section corresponding to the current link
        let section = document.querySelector(link.getAttribute('href'));

        // Get the position of the section relative to the viewport
        let sectionTop = section.offsetTop;
        let sectionHeight = section.offsetHeight;

        // If the section is in view, mark the link as active
        if (
            currentScroll >= sectionTop - 50 &&
            currentScroll < sectionTop + sectionHeight - 50
        ) {
            link.classList.add('active');

            // Clear the previous timeout, if any
            clearTimeout(scrollTimeout);

            // Set a timeout to scroll the active link into view after a short delay
            scrollTimeout = setTimeout(() => {
                link.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                    block: 'nearest',
                });
            }, 200); // Delay of 200ms after scrolling stops
        } else {
            link.classList.remove('active');
        }
    });
}

// Listen for scroll events
window.addEventListener('scroll', updateActiveLink);

// Also, call the function to set active state based on the initial scroll position
updateActiveLink();

// Focus on search field when clicking search
document.getElementById('searchButton').addEventListener('click', function() {
    const searchInput = document.getElementById('ajax-search');
    searchInput.focus();
});
//# sourceMappingURL=navigation.js.map
